module.exports = __webpack_public_path__ + "static/img/emoji_0.c72659f8.png";